import { get, isEmpty } from 'lodash';
import React, { useState, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Switch, useHistory } from 'react-router-dom';
import UpdatePassword from '../components/global/UpdatePassword';
import UserHeader from '../components/global/UserHeader';
import AppLoader from '../components/loaders/AppLoader';
import ClearingAgentBids from '../containers/ClearingAgent/Bids/ClearingAgentBids';
import Dashboard from '../containers/ClearingAgent/Dashboard';
import DisputesList from '../components/global/DisputesList';
// import MessageList from '../containers/ClearingAgent/Messages/MessageList';
import EditProfile from '../containers/ClearingAgent/Profile/EditProfile';
import Profile from '../containers/ClearingAgent/Profile/Profile';
import PaymentsList from '../containers/ClearingAgent/Receipts/PaymentsList';
import TruckList from '../containers/ForwardingAgent/Truck/TruckList';
import { ValidateRoutes } from './ClientRoute';
import VerificationModal from '../components/Modals/AgentVerificationModal';
import Documents from '../components/global/ShowDocument';
import UpdateDocuments from '../components/global/UpdateDocuments';
import Notification from '../components/global/Notification';
import Jobstatus from '../containers/ForwardingAgent/Jobstatus';
import DisputesDetails from '../components/global/DisputesDetails';
import TruckDetails from '../containers/ForwardingAgent/Truck/Details';
import NotificationMenuItem from '../components/global/NotificationBadge';
import {
  NT_FA_NEW_JOBS,
  NT_FA_DISPUTES,
  NT_FA_PROFILE,
  NT_FA_MY_JOBS,
  NT_FA_MY_TRUCKS,
  NT_CA_JOBS_UNDER_BIDDING,
} from '../helpers/constants';
import SuspensionModal from '../components/Modals/SuspensionModal';
import { hideSuspensionModal, hideDocumentModal } from '../redux/user/UserActions';
import DocumentModal from '../components/Modals/DocumentModal';
import { readNotification } from '../redux/notification/NotificationActions';

const ForwardingAgentRoute = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const userStoreState = useSelector((state) => state.user);
  const { user } = userStoreState;
  const [verficationModal, setVerificationModal] = useState(false);

  const [siderMemuToggle, setSiderMemuToggle] = useState(false);

  // const toggleVerificationModal = () => {
  //   setVerificationModal(!verficationModal);
  // };
  const toggleVerificationModal = useCallback(() => {
    //console.log(verficationModal);
    setVerificationModal(!verficationModal);
  }, [verficationModal]);

  // Auto-open verification modal on login if documents are not approved
  useEffect(() => {
    if (user && (user.identity_verified === 0 || user.identity_verified === 2)) {
      setVerificationModal(true);
    }
  }, [user]);
  const { match } = props;
  const { pathname } = props.location;

  if (isEmpty(user)) {
    return <AppLoader />;
  }

  const onMenuClick = (path, notificationTypes) => {
    history.push(path);
    setSiderMemuToggle(false);

    // mark the notifications of the menu as read
    if (notificationTypes) {
      dispatch(readNotification({ notificationTypes }));
    }
  };

  return (
    <div id="clearing-agent-page">
      <Helmet>
        <title>GoAgent</title>
      </Helmet>
      <UserHeader />
      <main id="main" className="main-block">
        <div className="bodycont">
          <div style={{ clear: 'both' }}></div>

          <div className="tab">
            <div className="cormen-btn">
              <label htmlFor="cormid"></label>
            </div>
            <div className="cormen">
              <input
                id="cormid"
                type="checkbox"
                checked={siderMemuToggle}
                onChange={(e) => setSiderMemuToggle(e.target.checked)}
              />
              <ul>
                <button
                  className={`tablinks ${
                    pathname.includes('/forwarding-agent/dashboard') ? 'active' : ''
                  }`}
                  onClick={() => onMenuClick('/forwarding-agent/dashboard', NT_FA_NEW_JOBS)}
                >
                  <NotificationMenuItem title="New Jobs" types={NT_FA_NEW_JOBS} />
                </button>{' '}
                {user.identity_verified === 0 || user.identity_verified === 2 ? (
                  <button
                    className={`tablinks ${
                      pathname.includes('/forwarding-agent/bids') ? 'active' : ''
                    }`}
                    onClick={() => {
                      toggleVerificationModal();
                    }}
                  >
                    <NotificationMenuItem title="My Jobs" types={NT_FA_MY_JOBS} />
                  </button>
                ) : (
                  <button
                    className={`tablinks ${
                      pathname.includes('/forwarding-agent/bids') ? 'active' : ''
                    }`}
                    onClick={() => {
                      // NT_CA_JOBS_UNDER_BIDDING is used as types because it is the default sub tab inside the page
                      // Jobs under bidding
                      onMenuClick('/forwarding-agent/bids', NT_CA_JOBS_UNDER_BIDDING);
                    }}
                  >
                    <NotificationMenuItem title="My Jobs" types={NT_FA_MY_JOBS} />
                  </button>
                )}
                <button
                  className={`tablinks ${pathname.includes('/trucks') ? 'active' : ''}`}
                  onClick={() => onMenuClick('/forwarding-agent/trucks', NT_FA_MY_TRUCKS)}
                >
                  <NotificationMenuItem title="My Trucks" types={NT_FA_MY_TRUCKS} />
                </button>
                <button
                  className={`tablinks ${
                    pathname.includes('/forwarding-agent/profile') ||
                    pathname.includes('/forwarding-agent/edit-profile')
                      ? 'active'
                      : ''
                  }`}
                  onClick={() => onMenuClick('/forwarding-agent/profile', NT_FA_PROFILE)}
                >
                  <NotificationMenuItem title="Profile" types={NT_FA_PROFILE} />
                </button>
                <button
                  className={`tablinks ${pathname.includes('/payments') ? 'active' : ''}`}
                  onClick={() => onMenuClick('/forwarding-agent/payments')}
                >
                  Transaction History
                </button>
                <button
                  className={`tablinks ${pathname.includes('/dispute') ? 'active' : ''}`}
                  onClick={() => onMenuClick('/forwarding-agent/disputes', NT_FA_DISPUTES)}
                >
                  <NotificationMenuItem title="Disputes" types={NT_FA_DISPUTES} />
                </button>
                {/* <button className={`tablinks ${pathname.includes('/messages') ? 'active' : ''}`} onClick={() => onMenuClick('/forwarding-agent/messages')}>
                  My Message
                </button> */}
                <button
                  className={`tablinks ${pathname.includes('/notifications') ? 'active' : ''}`}
                  onClick={() => onMenuClick('/forwarding-agent/notifications')}
                >
                  Messages
                </button>
              </ul>
            </div>
          </div>

          <Switch>
            <ValidateRoutes
              exact
              path={`${match.url}/dashboard`}
              component={Dashboard}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />

            <ValidateRoutes
              exact
              path={`${match.url}/profile`}
              component={Profile}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/profile/update-password`}
              component={UpdatePassword}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/documents`}
              component={Documents}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />

            <ValidateRoutes
              exact
              path={`${match.url}/edit-profile`}
              component={EditProfile}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/bids`}
              component={ClearingAgentBids}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/payments`}
              component={PaymentsList}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/trucks`}
              component={TruckList}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/trucks/details/:id`}
              component={TruckDetails}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/disputes`}
              component={DisputesList}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/dispute/details`}
              component={DisputesDetails}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            {/* <ValidateRoutes exact path={`${match.url}/messages`} component={MessageList} has_permission={get(user, 'type') === 'forwarding_agent'} /> */}
            <ValidateRoutes
              exact
              path={`${match.url}/update-documents`}
              component={UpdateDocuments}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/notifications`}
              component={Notification}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/job-status`}
              component={Jobstatus}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />
            <ValidateRoutes
              exact
              path={`${match.url}/job/details`}
              component={Jobstatus}
              has_permission={get(user, 'type') === 'forwarding_agent'}
            />

            <Redirect from={match.url} to={`${match.url}/dashboard`} />
          </Switch>
          <div className="clearfix"></div>
        </div>
        <VerificationModal
          verficationModal={verficationModal}
          toggleVerificationModal={toggleVerificationModal}
          container="clearing-agent-page"
        />
        {/* Modal to Display Suspension */}
        {userStoreState?.displaySuspensionModal && (
          <SuspensionModal
            container="clearing-agent-page"
            isOpen={userStoreState.displaySuspensionModal}
            toggle={() => {
              dispatch(hideSuspensionModal());
            }}
          />
        )}
        {/* Modal to Display Document */}
        {userStoreState?.displayDocumentModal && (
          <DocumentModal
            isOpen={userStoreState.displayDocumentModal}
            toggle={() => dispatch(hideDocumentModal())}
            documentToShow={userStoreState.documentToDisplay}
            container="clearing-agent-page"
          />
        )}
      </main>
    </div>
  );
};

export default ForwardingAgentRoute;
